const htmlTemplateForm = () => {
    const calculatorWrp = document.getElementById('calculator-how-much');

    if(!calculatorWrp) {
        return '<div>Loading...</div>';
    }

    const html = `<form id="howMuchWillCalculator" name="calcHowMuch" class="calc-wrp">
        <div class="calc-wrp__container">
            <div class="calculator">
                <div id="calculatorHowMuch" class="form-wrp">
                    <div class="form-wrp__line">
                        <div class="form-wrp__inner-line">
                            <div class="form-wrp__item">
                                <h3 class="form-wrp__header">Loan information</h3>
                                <label for="Amount" class="form-wrp__label">
                                    Amount, $
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="1000"
                                       name="amount"
                                       placeholder="270000"
                                       value="270000"
                                       id="Amount">
                            </div>

                            <div class="form-wrp__item">
                                <label for="interest-rate" class="form-wrp__label">
                                    Interest Rate, %
                                </label>
                                <input type="number"
                                       class="input"
                                       min="0"
                                       step="0.125"
                                       value="5.75"
                                       name="interest-rate"
                                       placeholder="5.75"
                                       id="interest-rate">
                            </div>

                            <div class="form-wrp__item">
                                <label for="length-years" class="form-wrp__label">
                                    Length, years
                                </label>
                                <input type="number"
                                       class="input"
                                       min="10"
                                       max="30"
                                       step="5"
                                       name="length-years"
                                       value="30"
                                       placeholder="10"
                                       id="length-years">
                            </div>

                            <div class="form-wrp__item full-item">
                                <h3 class="form-wrp__header">Property information</h3>
                                <label for="home-value" class="form-wrp__label">
                                    Home Value, $
                                </label>
                                <input type="number"
                                       class="input"
                                       name="home-value"
                                       min="0"
                                       step="1000"
                                       value="300000"
                                       placeholder="300000"
                                       id="home-value">
                            </div>
                        </div>
                    </div>
                    <div class="form-wrp__line">
                        <h3 class="form-wrp__header">Taxes and insurance information</h3>
                        <div class="form-wrp__inner-line">

                            <div class="form-wrp__item">
                                <div class="switcher-parent">
                                    <label class="switcher-label" for="switch-taxes-currency">
                                        <input type="radio"
                                               name="switch-taxes"
                                               data-target="annual-tax"
                                               value="$"
                                               class="switcher"
                                               id="switch-taxes-currency"
                                               checked="checked">
                                        <div class="radio-icon">$</div>
                                    </label>
                                    <label class="switcher-label" for="switch-taxes-percent">
                                        <input type="radio"
                                               name="switch-taxes"
                                               data-target="annual-tax"
                                               value="%"
                                               class="switcher"
                                               id="switch-taxes-percent">
                                        <div class="radio-icon">%</div>
                                    </label>
                                </div>
                                <label for="annual-tax" class="form-wrp__label">
                                    Annual Taxes
                                </label>
                                <input type="number"
                                       class="input"
                                       name="annual-tax"
                                       placeholder="7500"
                                       value="7500"
                                       min="0"
                                       step="1000"
                                       id="annual-tax">
                            </div>

                            <div class="form-wrp__item">
                                <div class="switcher-parent">
                                    <label class="switcher-label" for="switch-insurance-currency">
                                        <input type="radio"
                                               name="switch-insurance"
                                               value="$"
                                               class="switcher"
                                               id="switch-insurance-currency"
                                               checked="checked">
                                        <div class="radio-icon">$</div>
                                    </label>
                                    <label class="switcher-label" for="switch-insurance-percent">
                                        <input type="radio"
                                               name="switch-insurance"
                                               value="%"
                                               class="switcher"
                                               id="switch-insurance-percent">
                                        <div class="radio-icon">%</div>
                                    </label>
                                </div>
                                <label for="annual-insurance" class="form-wrp__label">
                                    Annual insurance
                                </label>
                                <div>
                                    <input type="number"
                                           class="input"
                                           value="2000"
                                           placeholder="2000"
                                           min="0"
                                           step="100"
                                           name="annual-insurance"
                                           id="annual-insurance">
                                </div>
                            </div>

                            <div class="form-wrp__item">
                                <div class="switcher-parent">
                                    <label class="switcher-label" for="switch-pmi-currency">
                                        <input type="radio"
                                               name="switch-pmi"
                                               value="$"
                                               class="switcher"
                                               id="switch-pmi-currency">
                                        <div class="radio-icon">$</div>
                                    </label>
                                    <label class="switcher-label" for="switch-pmi-percent">
                                        <input type="radio"
                                               name="switch-pmi"
                                               value="%"
                                               class="switcher"
                                               id="switch-pmi-percent"
                                               checked="checked">
                                        <div class="radio-icon">%</div>
                                    </label>
                                </div>
                                <label for="annual-pmi" class="form-wrp__label">
                                    Annual MI
                                </label>
                                <input type="number"
                                       class="input"
                                       name="annual-pmi"
                                       placeholder="0.1"
                                       step="0.1"
                                       value="0.5"
                                       min="0"
                                       id="annual-pmi">
                            </div>

                            <div class="form-wrp__item">
                                <button id="rerender" type="button" class="calc-wrp__btn-calc">
                                    Calculate now
                                    <svg width="7" height="10" viewBox="0 0 7 10" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.31812 9L5.68175 5L1.31812 1" stroke="white" stroke-width="2"
                                              stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>

                        </div>
                    </div>


                    <div class="tabs calculator-form">
                        <div class="tabs__nav">
                            <div class="tabs__tab" data-id="1">
                                Financial analysis
                            </div>
                            <div class="tabs__tab" data-id="2">
                                Plain English help
                            </div>
                        </div>

                        <div class="tabs__wrapper inline">
                            <div class="tabs__content" data-id="1">
                                <div class="calculator-form__content-wrapper">
                                    <div class="calculator-form__content-top">
                                        <div class="calculator-form__list">
                                            <div class="calculator-form__list-item">
                                                <div class="name-result">Monthly principal &amp; interest, $</div>
                                                <div class="result" data-calc-result="monthly-pi">0</div>
                                            </div>
                                            <div class="calculator-form__list-item">
                                                <div class="name-result">Monthly real estate taxes, $</div>
                                                <div class="result" data-calc-result="monthly-real-taxes">0</div>
                                            </div>
                                            <div class="calculator-form__list-item">
                                                <div class="name-result">Monthly insurance, $</div>
                                                <div class="result" data-calc-result="monthly-insurance">0</div>
                                            </div>
<!--                                            <div class="calculator-form__list-item" data-exclude="no-pmi">-->
<!--                                                <div class="name-result">Loan to value ratio</div>-->
<!--                                                <div class="result" data-calc-result="loan-value-ratio">0</div>-->
<!--                                            </div>-->
<!--                                            <div class="calculator-form__list-item" data-exclude="no-pmi">-->
<!--                                                <div class="name-result">Months with PMI</div>-->
<!--                                                <div class="result" data-calc-result="month-with-pmi">0</div>-->
<!--                                            </div>-->
                                            <div class="calculator-form__list-item" data-exclude="no-pmi">
                                                <div class="name-result">Monthly MI, $</div>
                                                <div class="result" data-calc-result="monthly-pmi">0</div>
                                            </div>
                                            <div class="calculator-form__list-item result-item">
                                                <div class="name-result total">Estimated monthly payments</div>
                                                <div class="result total" data-calc-result="monthly-payment">0</div>
                                            </div>
                                            <div class="calculator-form__list-item" data-exclude="no-pmi">
                                                <div class="name-result">Loan to value ratio</div>
                                                <div class="result" data-calc-result="loan-value-ratio">0</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tabs__content" data-id="2">
                                <div class="calculator-form__text-result-wrapper">
                                    <div class="text">
                                        <p>Your payment will vary depending on how much you will be
                                            borrowing, the interest rate, and the length of your loan term. Other
                                            factors also need to be taken into consideration, such as your
                                            taxes, your insurance, and your MI, all of which are included
                                            in your monthly house payment. Even the value of the home, occupancy type, and purpose of home loan could impact your monthly payment.</p>
                                        <p>Just as an example, let's say you are borrowing <span
                                                class="marker currency" data-calc-result="amount-no-pennies">0</span> for
                                            <span class="marker" data-calc-result="length-years">0</span> years with
                                            an interest rate of <span class="marker percent"
                                                                      data-calc-result="interest-rate">0</span>.
                                            If the value of your home is
                                            <span class="marker currency" data-calc-result="home-value-no-pennies">0</span>,
                                            your property taxes are <span class="marker currency"
                                                                      data-calc-result="annual-taxes">0</span> per
                                            year and
                                            your insurance is <span class="marker currency"
                                                                    data-calc-result="annual-insurance">0</span> per
                                            year, you can expect to be
                                            making a <span class="marker">total payment of </span><span
                                                    class="marker currency"
                                                    data-calc-result="monthly-payment">0</span>. This is because you
                                            need to
                                            pay <span class="marker currency" data-calc-result="monthly-pi">0</span>
                                            toward the actual loan, plus <span class="marker currency"
                                                                               data-calc-result="monthly-real-taxes">0</span>
                                            for real
                                            estate taxes and <span class="marker currency"
                                                                   data-calc-result="monthly-insurance">0</span>
                                            toward insurance.</p>
                                        <p data-exclude="no-pmi">
                                            <span>
                                            Since your loan to value ratio is <span class="marker percent" data-calc-result="loan-value-ratio">0</span>,
                                                you may also have to pay Mortgage Insurance (MI) which will add an extra
                                                <span class="marker" data-calc-result="monthly-pmi">0</span> a month.
                                                Depending on your loan program the MI may drop off or cancel and you might save yourself some money each month.
                                                Canceling your MI will require a reappraisal of your home in most cases.
<!--                                                Don't forget to drop the MI when the <span class="marker" data-calc-result="month-with-pmi">0</span>-->
<!--                                                months is complete and you might save yourself some money each month.-->
<!--                                                Canceling your MI will require a reappraisal of your home in most cases.-->
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="calc-wrp__btn-box">
                        <button type="button" class="calc-wrp__btn-calc secondary" data-modal="modalSendResult">
                            Send now
                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.31812 9L5.68175 5L1.31812 1" stroke="white" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
                <!--                    modal-->
                <div class="modal" id="modalSendResult">
                    <div class="modal__bg modal-exit"></div>

                    <div class="modal__container">
                        <button class="modal__close modal-exit">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.00081 14L14 1.00081M1 1L13.9992 13.9992" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <h3 class="modal__title">Send me my results</h3>
                        <div class="modal__body">
                            <div class="form-send">
                                <div class="form-send__input-box">
                                    <label for="email" class="form-send__label">Email address</label>
                                    <input id="email" type="email" class="form-send__input" name="email" placeholder="Enter your email">
                                </div>

                                <div class="form-send__input-box">
                                    <label for="name" class="form-send__label">Name</label>
                                    <input id="name" type="text" class="form-send__input" name="name" placeholder="Enter your name">
                                </div>

                                <div class="form-send__input-box">
                                    <label for="phone" class="form-send__label">Phone</label>
                                    <input id="phone" type="tel" class="form-send__input" name="phone" placeholder="Enter your phone">
                                </div>
                            </div>
                            <div class="form-send__status-ok hide">Success!</div>
                            <div class="form-send__status-fail hide">Error!</div>
                            <button type="submit" 
                            class="calc-wrp__btn-calc" 
                            data-text="Prequalify Now" 
                            data-wait="Loading..." 
                            data-success="Success!" 
                            data-error="Error!">
                            Send Now
                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.31812 9L5.68175 5L1.31812 1" stroke="white" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>`;

    calculatorWrp.insertAdjacentHTML("afterbegin", html);

    return true;
};

export default htmlTemplateForm;